import React from 'react'

interface FeedTableIconProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const FeedTableIcon: React.FC<FeedTableIconProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<path d='M9 3V21' stroke={color} strokeWidth='2' strokeLinecap='round' />
		<path
			d='M5.04939 3C5.04938 11.625 4.25927 12 9 12'
			stroke={color}
			strokeWidth='2'
			strokeLinecap='round'
		/>
		<path
			d='M12.9506 3C12.9506 11.625 13.7407 12 9 12'
			stroke={color}
			strokeWidth='2'
			strokeLinecap='round'
		/>
		<path
			d='M18.9448 3V21'
			stroke={color}
			strokeWidth='2'
			strokeLinecap='round'
		/>
		<path
			d='M18.9448 3C17.4448 8.5 15.4449 14 18.9448 14'
			stroke={color}
			strokeWidth='2'
			strokeLinecap='round'
		/>
	</svg>
)

export default FeedTableIcon
